export async function configuredUserPoolId(): Promise<string | null> {
  try {
    const cacheBust = import.meta.env.DEV ? `?t=${Date.now()}` : '';
    const res = await fetch(`/amplify_outputs.json${cacheBust}`, { cache: 'no-store' });
    if (!res.ok) return null;
    const outputs = (await res.json()) as { auth?: { user_pool_id?: string } };
    return outputs.auth?.user_pool_id ?? null;
  } catch {
    return null;
  }
}

export function userPoolIdFromIdToken(token: string): string | null {
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const payload = JSON.parse(
      atob(part.replace(/-/g, '+').replace(/_/g, '/')),
    ) as { iss?: string };
    const iss = payload.iss ?? '';
    const match = iss.match(/\/([A-Za-z0-9_-]+)$/);
    return match?.[1] ?? null;
  } catch {
    return null;
  }
}

/** Actionable copy when a Lambda rejects the Cognito id token (401). */
export async function cognitoAuthFailureMessage(
  status: number,
  apiError: string | undefined,
  token: string | null,
): Promise<string> {
  const err = apiError?.trim() || 'Request failed';
  if (status !== 401) return err;

  const configured = await configuredUserPoolId();
  const sessionPool = token ? userPoolIdFromIdToken(token) : null;
  if (configured && sessionPool && configured !== sessionPool) {
    return `Sign-in is for a different Cognito pool than this dev server (${sessionPool} vs ${configured}). Sign out, refresh, then sign in again — use npm run web:sandbox with sandbox users, or npm run web:live for production.`;
  }
  if (/sign in required/i.test(err)) {
    return 'Sign in required. Sign out, refresh the page, and sign in again (your session may have expired).';
  }
  return 'Your session expired or does not match this backend. Sign out, refresh the page, and sign in again.';
}
